export enum Onboarding {
  DEPLOY,
  GENERATE,
  ACCESS,
  SIGNLESS,
}
